import http from 'core/http-common'

import {
  IAvailableParkAreas,
  IFilteredParkAreaList,
  IAvailableParkAreasReq,
  ISaveParkAreaReservationReq,
} from 'types/ParkAreaType'
import DateUtil from 'utils/DateUtil'

class ParkAreaService {
  getParkAreaDetailByLocationId(locationId: number) {
    return http.get(`ParkAreaService/GetByLocationId?locationId=${locationId}`)
  }

  getParkAreaLocations() {
    return http.get<any>(`ParkAreaService/GetLocationList`)
  }

  getParkAreaFilteredList(data: IAvailableParkAreasReq) {
    return http.post<IFilteredParkAreaList[]>(`ParkArea/GetFilteredList`, data)
  }

  getAvailableParkAreaList(reservationDate: Date | undefined) {
    let date: string
    if (!reservationDate) date = ''
    else date = DateUtil.formatStringToDateTime(DateUtil.getStartOfDay(reservationDate)?.toISOString())
    return http.get<IAvailableParkAreas>(`ParkArea/GetAvailableParkAreas?reservationDate=${date}`)
  }

  saveParkAreaReservation(data: ISaveParkAreaReservationReq) {
    return http.post('ParkAreaReservation/SaveReservation', data)
  }

  deleteParkAreaReservation(data: ISaveParkAreaReservationReq) {
    return http.post('ParkAreaReservation/DeleteReservation', data)
  }
}

export default new ParkAreaService()
